import React from 'react'
import { Modal, ModalHeader, ModalBody } from 'reactstrap'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import { EMPTY_OBJECT } from '../../../constants/globalConstants'

function RateDetailsModal(props) {
    const { rateDetailModal, setRateDetailModal, rateObj } = props
    const toggle = () => setRateDetailModal({...rateDetailModal, modal: !rateDetailModal.modal})
    return (
        <>
            <Modal isOpen={rateDetailModal.modal} scrollable={true} toggle={toggle}>
                <ModalHeader toggle={toggle}>Rate Details</ModalHeader>
                <ModalBody >
                    <table className='table table-sm '>
                        
                        {rateObj.data?.length && rateObj.data?.map((item, itemIndex) => <tr  key={'rate_detail_'+itemIndex}>
                            <td className='p-0 m-0 border-bottom pb-1'>
                                <small className="p-0 fw-bold">{item?.rate_band_description}</small>
                                

                          
                            <div className='d-flex p-0 m-0 justify-content-between align-items-center'>
                             
                                <small className='text-muted small p-0'>{Number(item?.min_stay).toFixed(2)} - {Number(item?.max_stay).toFixed(2)}</small>
                                <small className="p-0 fw-bold">${Number(item?.price).toFixed(2)}</small>
                            </div>
                            </td>
                        </tr>)}
                    </table>
                </ModalBody>
            </Modal>
        </>
    )
}

RateDetailsModal.propTypes = {
    dispatch: PropTypes.func,
    rateDetailModal: PropTypes.object,
    rateObj: PropTypes.object,
    setRateDetailModal: PropTypes.func
}

RateDetailsModal.defaulProps = {
    dispatch: noop,
    rateDetailModal: EMPTY_OBJECT,
    rateObj: EMPTY_OBJECT,
    setRateDetailModal: noop
}

function mapStateToProps() {
    return {}
}

export default connect(mapStateToProps)(RateDetailsModal)